import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '@/contexts/NotificationContext';

export default function SignalToast() {
  const { latestSignal, clearLatestSignal } = useNotification();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState<typeof latestSignal>(null);

  useEffect(() => {
    if (!latestSignal) return;
    setCurrent(latestSignal);
    setVisible(true);
    const t = setTimeout(() => {
      setVisible(false);
      setTimeout(clearLatestSignal, 400);
    }, 5000);
    return () => clearTimeout(t);
  }, [latestSignal, clearLatestSignal]);

  if (!current) return null;

  return (
    <div
      role="status"
      className="fixed left-4 right-4 z-50"
      style={{
        top: '72px',
        transform: visible ? 'translateY(0)' : 'translateY(-120px)',
        opacity: visible ? 1 : 0,
        transition: 'all 0.35s cubic-bezier(0.4,0,0.2,1)',
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <div
        className="rounded-2xl px-4 py-3 flex items-center gap-3"
        style={{
          background: 'white',
          boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
          borderLeft: '4px solid #6366F1',
        }}
      >
        {/* Icon */}
        <div
          className="w-10 h-10 flex items-center justify-center rounded-xl flex-shrink-0"
          style={{ background: '#EEF2FF' }}
        >
          <i
            className="ri-notification-3-fill"
            style={{ color: '#6366F1', fontSize: '20px' }}
          />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <p className="text-gray-900 font-bold text-sm">
            {current.title}
          </p>
          <p className="text-gray-400 text-xs mt-0.5 truncate">
            {current.body}
          </p>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-1.5 flex-shrink-0">
          <button
            onClick={() => { navigate('/notifications'); setVisible(false); }}
            className="text-indigo-500 text-xs font-medium px-2.5 py-1.5 bg-indigo-50 rounded-lg"
          >
            查看
          </button>
          <button
            onClick={() => { setVisible(false); setTimeout(clearLatestSignal, 400); }}
            aria-label="关闭通知"
            className="w-7 h-7 flex items-center justify-center rounded-lg bg-gray-100"
          >
            <i className="ri-close-line text-gray-400 text-sm" />
          </button>
        </div>
      </div>
    </div>
  );
}